import { BoxProps, Box, HStack } from "@chakra-ui/layout";
import { Textarea, TextareaProps } from "@chakra-ui/textarea";
import React from "react";
import { BaseFieldProps, FieldWrapper } from "../FieldWrapper/FieldWrapper";

interface TextAreaProps extends BaseFieldProps {
  boxProps?: BoxProps;
  leftElement?: React.ReactNode;
  rightElement?: React.ReactNode;
}

export const TextArea = ({
  name,
  label,
  id,
  helperText,
  boxProps,
  leftElement,
  rightElement,
  horizontal,
  fcProps,
  labelProps,
  valueProps,
  hideField,
  labelRightElement,
  ...textAreaProps
}: TextAreaProps & TextareaProps) => {
  return (
    <FieldWrapper
      name={name}
      id={id}
      label={label}
      helperText={helperText}
      horizontal={horizontal}
      valueProps={valueProps}
      labelProps={labelProps}
      fcProps={fcProps}
      hideField={hideField}
      labelRightElement={labelRightElement}
    >
      {({ field }) => (
        <HStack w="100%">
          {leftElement}
          <Box w="100%" bgColor="white" {...boxProps}>
            <Textarea
              {...field}
              value={field.value == null ? "" : field.value}
              fontSize="xs"
              {...textAreaProps}
            />
          </Box>
          {rightElement}
        </HStack>
      )}
    </FieldWrapper>
  );
};
